import "./helpers.js";
import "./header.js";
import "./assets.js";

Helpers.postponeExecution(async () => {
	try {
		await Helpers.loadScript(assets.AOS.js);

		AOS.init({
			duration: 500,
			delay: 50
		});

		window.addEventListener("load", AOS.refresh);
	} catch (e) {
		console.error(e);
	}
});